"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerDeviceDto = void 0;
class CustomerDeviceDto {
    constructor(params) {
        this.token = "";
        this.createdAt = "";
        this.updatedAt = "";
        this.lastRegisteredAt = "";
        this.platform = "";
        this.gcm = false;
        this.tokenType = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.appId = params.appId;
        this.token = params.token;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        this.lastRegisteredAt = params.lastRegisteredAt;
        this.locationId = params.locationId;
        this.count = params.count;
        this.platform = params.platform;
        this.gcm = params.gcm;
        this.tokenType = params.tokenType;
        this.customerId = params.customerId;
        this.loginId = params.loginId;
        this.lastDeviceCheck = params.lastDeviceCheck;
    }
}
exports.CustomerDeviceDto = CustomerDeviceDto;
//# sourceMappingURL=CustomerDeviceDto.js.map